import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { ENVIRONMENT } from '@privanot/shared-ui/providers';
import { AUTH_CONFIG_PATH, EntraAuthService } from '@client/auth/services/entra-auth.service';

/**
 * Adds the Entra bearer token to Client Service requests. BASE_URL is read per request: the desktop app swaps it for
 * the service's loopback port at start-up, and it is '' (same origin) in the hosted app.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const baseUrl = inject(ENVIRONMENT).BASE_URL;
    const auth = inject(EntraAuthService);
    const servicePrefix = `${baseUrl}/`;

    if (!req.url.startsWith(servicePrefix) || req.url === `${servicePrefix}${AUTH_CONFIG_PATH}`) {
        return next(req);
    }

    return from(auth.getAccessToken()).pipe(
        switchMap((token) => next(token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req)),
    );
};
